import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    ticketId: Number,
    creatingMessage: String,
    sendingMessage: String,
    reopeningMessage: String,
    errorCreatingMessage: String,
    errorSendingMessage: String,
    errorReopeningMessage: String
  }

  async contactSupport(event) {
    event.preventDefault()

    const button = event.currentTarget
    const originalText = button.innerHTML
    button.disabled = true
    button.innerHTML = `<span class="animate-pulse">${this.creatingMessageValue}</span>`

    try {
      const response = await fetch('/support_tickets', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken,
          'Accept': 'application/json'
        }
      })

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
      const data = await response.json()

      if (data.success && data.chat_url) {
        window.open(data.chat_url, '_blank')
        setTimeout(() => window.location.reload(), 500)
      }
    } catch (error) {
      console.error('Failed to create ticket:', error)
      alert(this.errorCreatingMessageValue)
      button.disabled = false
      button.innerHTML = originalText
    }
  }

  async nudgeTicket(event) {
    event.preventDefault()

    const button = event.currentTarget
    const ticketId = this.ticketIdValue
    const originalText = button.innerHTML

    if (!ticketId) return

    button.disabled = true
    button.innerHTML = `<span class="animate-pulse">${this.sendingMessageValue}</span>`

    try {
      const response = await fetch(`/support_tickets/${ticketId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken,
          'Accept': 'application/json'
        }
      })

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
      const data = await response.json()

      if (data.success && data.chat_url) {
        window.open(data.chat_url, '_blank')
      }
    } catch (error) {
      console.error('Failed to nudge ticket:', error)
      alert(this.errorSendingMessageValue)
    } finally {
      button.disabled = false
      button.innerHTML = originalText
    }
  }

  async reopenTicket(event) {
    event.preventDefault()

    const button = event.currentTarget
    const ticketId = this.ticketIdValue
    const originalText = button.innerHTML

    if (!ticketId) return

    button.disabled = true
    button.innerHTML = `<span class="animate-pulse">${this.reopeningMessageValue}</span>`

    try {
      const response = await fetch(`/support_tickets/${ticketId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken,
          'Accept': 'application/json'
        }
      })

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
      const data = await response.json()

      if (data.success) {
        setTimeout(() => window.location.reload(), 500)
      }
    } catch (error) {
      console.error('Failed to reopen ticket:', error)
      alert(this.errorReopeningMessageValue)
      button.disabled = false
      button.innerHTML = originalText
    }
  }

  get csrfToken() {
    const token = document.querySelector('[name="csrf-token"]')
    return token ? token.content : ''
  }
}
